// Authenticatd by default
import { jwtDecode } from 'jwt-decode';

// Helper function to clear all auth data
const clearAllAuthData = () => {
  localStorage.removeItem('authenticated');
  localStorage.removeItem('role');
  localStorage.removeItem('tokenLogin');
  localStorage.removeItem('hz-tokenLogin');
  localStorage.removeItem('user_name');
  localStorage.removeItem('user_id');
  localStorage.removeItem('appName');
};

// Synchronous check - runs immediately on import to clean up invalid auth state
// This prevents the re-render loop by clearing role BEFORE React reads it
const checkAuthSync = () => {
  const authenticated = localStorage.getItem('authenticated');
  const appName = localStorage.getItem('appName');
  const hzToken = localStorage.getItem('hz-tokenLogin');
  const token = localStorage.getItem('tokenLogin');

  // Quick checks - if any of these fail, clear everything
  if (!authenticated || appName !== 'aman' || !hzToken || !token) {
    clearAllAuthData();
    return false;
  }

  try {
    const decodedToken = jwtDecode(token);
    
    // Check token expiration
    if (decodedToken.exp * 1000 < Date.now()) {
      clearAllAuthData();
      return false;
    }

    // Validate token structure
    if (!decodedToken.acls2 || !decodedToken.acls2.user_type_Aman) {
      clearAllAuthData();
      return false;
    }

    return true;
  } catch (error) {
    clearAllAuthData();
    return false;
  }
};

// Run the sync check immediately when this module loads
checkAuthSync();

function setUserCredentials(role, response) {
  localStorage.setItem('role', role.toLowerCase());
  localStorage.setItem('tokenLogin', response.token2);
  localStorage.setItem('user_name', response.UserName);
  localStorage.setItem('user_id', response.UserId);

}
const authProvider= {
  login: ({ username, password }) => {

    const request = new Request('https://sso-api.tatweertransit.com/token', {
      method: "POST",
      body: JSON.stringify({ username, password }),
      headers: new Headers({ "Content-Type": "application/json" })
    });
    return fetch(request)
      .then(response => {
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then(response => {
        const decoded = jwtDecode(response.token2);
        //console.log("decoded", decoded);
        //console.log("response", response);


        if (decoded.acls2.acl_Aman) {
          let role = decoded.acls2.user_type_Aman;
          if (['Admin', 'Contractor', 'SaftySupervisor', 'AreaManager', 'saftymanager', 'trainer','areamangertrainer','saftysupervisortrainer','seniorareamanager','inspector','readonly','biuser'].includes(role)) {

            setUserCredentials(role, response);
             return Promise.resolve(response.token2);

          }
        } else {

          localStorage.removeItem('authenticated');
          localStorage.removeItem('tokenLogin');
          localStorage.removeItem('user_name');
          localStorage.removeItem('user_id');
          localStorage.removeItem('hz-tokenLogin');
          localStorage.removeItem('role');
          return Promise.reject();

        }








        // localStorage.setItem("token", token);
      }).then(token => {

        const request = new Request('https://reports-api.tatweertransit.com/Aman/validate?token=' + token, {
          method: "GET",
          // body: JSON.stringify({ token }),
          headers: new Headers({ "Content-Type": "application/json" })
        });

        return fetch(request)
        .then(response => {
          if (response.status < 200 || response.status >= 300) {
            throw new Error(response.statusText);
          }
          return response.json();
        })
        .then(response => {
          //console.log('Token:', response.token); // Logs the token value, confirming this works.
          try {
            // Try-catch block to catch any exceptions that might be thrown by localStorage operations.
            localStorage.setItem('authenticated', true);
            localStorage.setItem('appName', "aman");
            //console.log('Authenticated set in localStorage'); // Confirm this line was executed.
            
            localStorage.setItem('hz-tokenLogin', response.token);
            //console.log('Token set in localStorage'); // Confirm this line was executed.
          } catch (e) {
            // Log any localStorage errors.
            console.error('Error setting localStorage:', e);
          }

          setTimeout(() => {
            window.location.reload();
        }, 2000); // 1000 milliseconds = 1 second 
          
          return Promise.resolve(); // Should now be unnecessary since the lines above don't throw.
        })
        .catch(error => {
          // Catch any errors that happened during the promise chain.
          console.error('An error occurred in the promise chain:', error);
                    return Promise.reject(error); // Properly reject the promise

        });
      
      



      });





  },

  logout: () => {
    clearAllAuthData();
    return Promise.resolve();
  },
  checkError: ({ status }) => {
    if (status === 401 || status === 403) {
      clearAllAuthData();
      return Promise.reject();
    }
    return Promise.resolve();
  },
  checkAuth: () => {
    // Use the same sync check logic
    if (!checkAuthSync()) {
      return Promise.reject({ message: 'Not authenticated', redirectTo: '/login' });
    }
    return Promise.resolve();
  },

  getPermissions: () => {
    const role = localStorage.getItem('role');
    return Promise.resolve(role);
  },


};
export default authProvider;